import * as React from 'react';
import { PVABadge } from './PVABadge';
import { Style, StyleTag, StyleText } from '../../../models';
import './PVAStyle.css';
import './PVAStyleBreakdown.css';
import { computed } from 'mobx';
import { PonderaModal } from '../../inclinationmodals';

interface PVAStyleBreakdownProps {
    style: Style;
    brief: string;
    content: string;
    name: string;
    showSecondaryStyle: boolean;
}

export class PVAStyleBreakdown extends React.Component<PVAStyleBreakdownProps, { modalVisible: boolean, secondaryStyleModalVisible: boolean }> {
    constructor(props: PVAStyleBreakdownProps) {
        super(props);

        this.state = {
            modalVisible: false,
            secondaryStyleModalVisible: false
        };
    }

    @computed get showSecondaryStyle() {
        if (this.props.showSecondaryStyle === null) {
            return false;
        }
        return this.props.showSecondaryStyle;
    }

    toggleModal() {
        this.setState({ modalVisible: !this.state.modalVisible });
    }

    render() {
        const subCoreStyles = this.props.style.styleTexts.filter((styleText: StyleText) => {
            return styleText.styleTextType === 'subCore';
        });

        return (
            <div className={`pva-style ${this.props.style.name} pva-style-modal`}>
                <table>
                    <tbody>
                        <tr className="hidden-xs">
                            <td style={{width: '80px'}}>
                                <PVABadge style={this.props.style.name} badge={this.props.style.name[0]} />
                            </td>
                            <td style={{width: '120px'}}>
                                <div className="pva-style-content pad-badge-modal">
                                    <h5>PVA Style</h5>
                                    <h3>
                                        {this.props.style.name}
                                    </h3>
                                    {this.props.showSecondaryStyle && (this.props.style.subCore || this.props.style.useSecondaryStyle) && subCoreStyles.length > 0 && subCoreStyles.map((styleText: StyleText, ind: number) => {
                                        return <div key={`st2-subCore-${ind}`}>
                                            <small>
                                                {this.props.style.secondaryStyle && this.props.style.secondaryStyle.name
                                                && <a className="subCoreLink" onClick={() => {this.setState({secondaryStyleModalVisible:true});}}>{this.props.style.secondaryStyle.name}</a>}
                                            </small>
                                            {this.props.style.useSecondaryStyle && <PonderaModal
                                                style={this.props.style}
                                                simpleTitle={true}
                                                show={this.state.secondaryStyleModalVisible}
                                                title={this.props.style.name + ' <span style="font-size:70%">with a Secondary Style of ' + this.props.style.secondaryStyle.name + '</span>'}
                                                content={styleText.value}
                                                onHide={(e: any) => {this.setState({secondaryStyleModalVisible:false});}}
                                            />}
                                        </div>;
                                    })}
                                </div>
                            </td>
                            <td>
                                <div className="pva-style-content">
                                    <div className="brief" dangerouslySetInnerHTML={{ __html: this.props.brief}} />
                                </div>
                            </td>
                        </tr>
                        <tr className="visible-xs">
                            <td style={{width: '80px'}}>
                                <PVABadge style={this.props.style.name} badge={this.props.style.name[0]} />
                            </td>
                            <td colSpan={2}>
                                <div className="pva-style-content pad-badge-modal">
                                    <h5>PVA Style</h5>
                                    <h3>{this.props.style.name}</h3>
                                </div>
                            </td>
                        </tr>
                        <tr className="visible-xs">
                            <td colSpan={3}>
                                <div className="pva-style-content" style={{paddingTop: '15px'}}>
                                    <div className="brief" dangerouslySetInnerHTML={{ __html: this.props.brief}} />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={3}>
                                <div className="pva-style-tags">
                                    {
                                        this.props.style.styleTags && this.props.style.styleTags.length > 0 && this.props.style.styleTags.map((styleTag: StyleTag, ind: number) => {
                                            return <div key={`st-${ind}`} className="tag">{styleTag.value}</div>;
                                        })
                                    }
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVAStyleBreakdown.tsx